<template>
  <div class="xf-message-box" v-if="showMessageBox">
    <div class="message-box-container">
      <div class="message-header">
        <div class="header-content">
          <span class="header-text">{{ title }}</span>
          <span class="iconfont iconguanbi icon-reset" @click="close"></span>
        </div>
      </div>
      <div class="message-content">
        <div class="iconfont icontishi"></div>
        <div class="message-text">
          <span>{{ message }}</span>
        </div>
      </div>
      <div class="message-footer">
        <button class="btn btn-confirm" v-if="isShowConfirm" @click="confirm">
          {{ confirmText }}
        </button>
        <button class="btn btn-cancel" v-if="isShowCancel" @click="cancel">
          {{ cancelText }}
        </button>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "xfMessageBox",
  data() {
    return {
      showMessageBox: false
    };
  },
  props: {
    title: {
      type: String,
      default: "提示信息"
    },
    message: {
      type: String,
      default: "这是测试用的消息"
    },
    cancelText: {
      type: String,
      default: "取消"
    },
    confirmText: {
      type: String,
      default: "确定"
    },
    isShowCancel: {
      type: Boolean,
      default: true
    },
    isShowConfirm: {
      type: Boolean,
      default: true
    },
    infoIcon: {
      type: String,
      default: require("../../assets/images/icon-info.png")
    }
  },
  methods: {
    close() {
      this.showMessageBox = false;
    },
    show() {
      this.showMessageBox = true;
    },
    confirm() {
      this.$emit("confirm");
    },
    cancel() {
      this.$emit("cancel");
    }
  }
};
</script>
